import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (param) {
  const { data, exec } = useRequest({
    url: '',
    name: 'DELETE_HMI_ONLINE_CRAFT',
    method: 'DELETE',
  });

  useEffect(() => {
    if (param && JSON.stringify(param) !== '{}') {
      let url = `/api/devices/${param.device_id}/crafts/${param.id}/dispatch?craft_sn=${param.craft_sn}`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return data || {};
});
